import { useUserData } from '../../../common/UserProvider/UserProvider';
import { GoogleGAMAd } from '../../../common/components/GoogleGAMAd/GoogleGAMAd';
import { Link } from '../../../common/components/Link';
import {
  FilterChoice,
  SPECIALTY_DENTIST,
  SPECIALTY_GENERAL_PRACTICE,
} from '../../../common/components/SearchHeader/types/FilterChoice';
import { buildHeImgixUrl } from '../../../common/components/images/imgix';
import { useRouter } from '../../../common/hooks/useRouter';
import { env } from '../../../common/util/env';
import { PAGE_SIZE } from '../../constants';
import { Container } from './Sidebar.styles';
import { GPSidebarFilter, DentalSidebarFilter } from './SidebarFilters/SidebarFilters';

interface Props {
  totalSearchResults?: number;
  filters: FilterChoice;
}

export const Sidebar = ({ totalSearchResults = 0, filters }: Props) => {
  const { data: user } = useUserData();
  const router = useRouter();

  const isFindDentist = router?.asPath.includes('/find/dentist');
  const isFindGP = router?.asPath.includes('/find/doctor');

  const showSpecialistAd =
    !user &&
    filters.topic?.specialist !== SPECIALTY_DENTIST &&
    filters.topic?.specialist !== SPECIALTY_GENERAL_PRACTICE;

  return (
    <Container>
      <GoogleGAMAd
        adUnit="HealthEngine.web/results"
        slotId="gam_mrechalfpage_pos1"
        sizes={[
          [300, 250],
          [300, 600],
        ]}
        targetingArguments={{ pos: 1, env: env.GAM_ENVIRONMENT }}
      />
      <GoogleGAMAd
        adUnit="HealthEngine.web/results"
        slotId="gam_mrec_pos2"
        sizes={[[300, 250]]}
        targetingArguments={{ pos: 2, env: env.GAM_ENVIRONMENT }}
      />
      <GoogleGAMAd
        adUnit="HealthEngine.web/results"
        slotId="gam_mrec_pos3"
        sizes={[[300, 250]]}
        targetingArguments={{ pos: 3, env: env.GAM_ENVIRONMENT }}
      />
      {isFindDentist && totalSearchResults > PAGE_SIZE && <DentalSidebarFilter />}
      {isFindGP && totalSearchResults > PAGE_SIZE && <GPSidebarFilter />}
      {showSpecialistAd && (
        <Link
          to="https://practices.healthengine.com.au/list-your-practice/?pracsource=marketplace"
          target="_blank"
        >
          <img
            src={buildHeImgixUrl('public/images/list-your-practice_20210820082239.gif')}
            alt="List your practice link"
          />
        </Link>
      )}
    </Container>
  );
};
